module.exports = __webpack_public_path__ + "assets/img/login-v2.93dece44.svg";